import { ReactNode } from "react";
import styled, { keyframes } from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { MEDIA_QUERIES } from "context/media/MediaConstant";

export const StyledEmpOutWrapper = styled.div`
  @media ${MEDIA_QUERIES.MOBILE} {
    margin: 5px;
    flex-direction: column;
    width: 98%;
  }
`;

export const StyledOuterWrapper = styled.div`
  @media ${MEDIA_QUERIES.MOBILE} {
    height: 100%;
  }
`;

export const StyledEmpPanelItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  padding: 0 7px;
  border-radius: 5px;
  margin-bottom: 5px;

  &:nth-child(even) {
    background-color: ${DIGIPOSTHEME.colors.footerGrey};
  }

  &:nth-child(odd) {
    background-color: ${DIGIPOSTHEME.colors.white};
  }
`;

export const StyledItemMenuWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
`;

interface EmpPanelItemCircleProps {
  bgColor?: string;
  width?: string;
  height?: string;
  justifyContent?: "center" | "flex-start" | "flex-end" | "space-between";
  margin?: string;
  padding?: string;
}
export const StyledEmpPanelItemCircle = styled.div<EmpPanelItemCircleProps>`
  border-radius: 50%;
  background-color: ${({ bgColor }) =>
    bgColor ? bgColor : DIGIPOSTHEME.colors.primaryAkbankWhite} !important;
  border: 1px solid #f5f4f6;
  box-shadow: rgb(0 0 0 / 30%) 0px 1px 0px 1px;
  
  width: ${({ width = "40px" }) => width};
  height: ${({ height = "40px" }) => height};
  display: flex;
  justify-content: ${({ justifyContent = "center" }) => justifyContent};
  align-items: center;
  cursor: pointer;  
  margin: ${({ margin = "15px 0" }) => margin};
  padding: ${({ padding = "0" }) => padding};
}
`;

export const moveInLeft = keyframes`
0% {
   opacity: 0;
   transform: translateX(3rem);
  }

100% {
   opacity: 1;
   transform: translate(0);
  }
`;
export const StyledButtonAnimated = styled.div`
  animation: ${moveInLeft} 0.7s ease-in-out;
  margin: 16px 5px;

  @media ${MEDIA_QUERIES.MOBILE} {
    z-index: 999999;
    position: absolute;
    right: 57px;
  }
`;

interface ScrollEmpPanelProps {
  width?: string;
  maxHeight?: string;
}
export const StyledScrollEmpPanel = styled.div<ScrollEmpPanelProps>`
  background-color: ${DIGIPOSTHEME.colors.secondaryGrayTertiary};
  margin: 10px 0;
  border-radius: 5px;
  padding: 10px;
  width: ${({ width = "875px" }) => width};
  max-height: ${({ maxHeight = "750px" }) => maxHeight};
  height: 472px;
  overflow-y: auto;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  overflow-x: hidden;
`;

interface EmpActionButton {
  bgColor: string;
  children?: ReactNode;
}
export const StyledEmpPanelActionButton = styled.button<EmpActionButton>`
  width: 45px;
  height: 35px;
  background-color: ${({ bgColor }) => bgColor};
  border: none;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;

  &:active {
    transform: scale(0.9);
  }
  /*&:hover {
    box-shadow: rgba(0, 0, 0, 0.35) 0px -50px 36px -28px inset;
  }*/

  @media ${MEDIA_QUERIES.MOBILE} {
    width: auto;
    margin: 0;
    padding: 2px;
  }
`;

export const StyledEmpTitleWrapper = styled.div`
  width: 100%;
  height: 30px;
  background-color: ${DIGIPOSTHEME.colors.headerRed};
  margin: 30px 0;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
`;

export const StyledAddButtonWrapper = styled.button`
  margin: 0 0 30px 0;
  height: 30px;
  background-color: ${DIGIPOSTHEME.colors.footerGrey};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 5px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border: none;
`;
